module.exports = __webpack_public_path__ + "img/rumia_sc2.a76b51ee.png";